module.exports = __webpack_public_path__ + "img/des-1.dab3597b.png";